export type SfxKey =
  | 'ui_click'
  | 'ui_toggle'
  | 'bet_change'
  | 'spin_start'
  | 'spin_stop'
  | 'reel_stop'
  | 'fruit_cut'
  | 'juice_splash'
  | 'sector_fill'
  | 'sector_drain'
  | 'skull_hit'
  | 'gray_hit'
  | 'bonus_win'
  | 'instant_cashout'
  | 'cashout'
  | 'turbo_on'
  | 'turbo_off'
  | 'bonus_reel';

export type MusicKey = 'bgm';

export type SoundDef = {
  src: string;
  volume: number;
  concurrency?: number;
  rateVariance?: number; // +/- variance from 1.0
};

export const SFX: Record<SfxKey, SoundDef> = {
  ui_click: { src: '/assets/audio/ui_click.wav', volume: 0.7, concurrency: 4, rateVariance: 0.03 },
  ui_toggle: { src: '/assets/audio/ui_toggle.wav', volume: 0.7, concurrency: 2, rateVariance: 0.02 },
  bet_change: { src: '/assets/audio/bet_change.wav', volume: 0.65, concurrency: 3, rateVariance: 0.03 },
  spin_start: { src: '/assets/audio/spin_start_tick.wav', volume: 0.4, concurrency: 1, rateVariance: 0.0 },
  spin_stop: { src: '/assets/audio/spin_stop.wav', volume: 0.85, concurrency: 2, rateVariance: 0.02 },
  reel_stop: { src: '/assets/audio/reel_stop.wav', volume: 0.75, concurrency: 2, rateVariance: 0.02 },
  fruit_cut: { src: '/assets/audio/fruit_cut_v2.wav', volume: 0.55, concurrency: 1, rateVariance: 0.0 },
  juice_splash: { src: '/assets/audio/juice_splash.wav', volume: 0.8, concurrency: 3, rateVariance: 0.03 },
  sector_fill: { src: '/assets/audio/sector_fill_v2.wav', volume: 0.45, concurrency: 1, rateVariance: 0.0 },
  sector_drain: { src: '/assets/audio/sector_drain.wav', volume: 0.7, concurrency: 2, rateVariance: 0.02 },
  skull_hit: { src: '/assets/audio/skull_hit.wav', volume: 0.9, concurrency: 2, rateVariance: 0.02 },
  gray_hit: { src: '/assets/audio/gray_hit.wav', volume: 0.7, concurrency: 2, rateVariance: 0.02 },
  bonus_win: { src: '/assets/audio/bonus_win.wav', volume: 0.95, concurrency: 1, rateVariance: 0.01 },
  instant_cashout: { src: '/assets/audio/instant_cashout.wav', volume: 0.85, concurrency: 2, rateVariance: 0.02 },
  cashout: { src: '/assets/audio/cashout.wav', volume: 0.9, concurrency: 1, rateVariance: 0.02 },
  turbo_on: { src: '/assets/audio/turbo_on.wav', volume: 0.7, concurrency: 1, rateVariance: 0.02 },
  turbo_off: { src: '/assets/audio/turbo_off.wav', volume: 0.7, concurrency: 1, rateVariance: 0.02 },
  bonus_reel: { src: '/assets/audio/bonus_reel.wav', volume: 0.7, concurrency: 1, rateVariance: 0.02 },
};

export const MUSIC: Record<MusicKey, SoundDef> = {
  bgm: { src: '/assets/audio/bgm.wav', volume: 0.35, concurrency: 1 },
};
